var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"suggestion-link",on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_c('svg-icon',{staticClass:"mr-1",attrs:{"color":"black","type":"mdi","size":"22","path":_vm.iconPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }